import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Flag, Loader2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { owner } from "@/lib/owner-api";

export default function OwnerFlags() {
  const [flags, setFlags] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchList = async () => {
    setLoading(true);
    try { setFlags(await owner.flags()); } catch (err) { console.warn("Flags load failed:", err); }
    setLoading(false);
  };
  useEffect(() => { fetchList(); }, []);

  const toggle = async (key, enabled) => {
    try {
      await owner.updateFlag(key, enabled);
      toast.success(`${key}: ${enabled ? "ON" : "OFF"}`);
      fetchList();
    } catch (err) { console.warn("Flag toggle failed:", err); toast.error("Gagal"); }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white">Feature Flags</h1>
        <p className="text-sm text-gray-500 mt-1">Aktifkan atau matikan fitur di seluruh platform.</p>
      </div>

      <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden">
        {loading ? <div className="p-16 flex justify-center"><Loader2 className="animate-spin text-emerald-400" /></div>
          : (
            <div className="divide-y divide-gray-800">
              {flags.map((f) => (
                <div key={f.key} className="p-5 flex items-center justify-between hover:bg-gray-800/40" data-testid={`flag-${f.key}`}>
                  <div className="flex items-start gap-3 flex-1">
                    <div className="w-9 h-9 rounded-lg bg-emerald-900/30 border border-emerald-800 flex items-center justify-center text-emerald-400">
                      <Flag size={16} />
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <code className="text-sm font-mono font-bold text-white">{f.key}</code>
                        <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded ${f.enabled ? "bg-emerald-900/40 text-emerald-300" : "bg-gray-800 text-gray-500"}`}>
                          {f.enabled ? "ON" : "OFF"}
                        </span>
                      </div>
                      <p className="mt-1 text-xs text-gray-400">{f.description}</p>
                    </div>
                  </div>
                  <Switch checked={!!f.enabled} onCheckedChange={(v) => toggle(f.key, v)} data-testid={`flag-toggle-${f.key}`} />
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
